import { MonitorX } from 'lucide-react';
import type { ScreenDef } from '@/lib/types';

/** Windows'a özgü (DLL, yerel donanım, dosya sistemi) Delphi işlemleri için açıklama ekranı */
export function ExternalScreen({ screen, notImplemented }: { screen: ScreenDef; notImplemented?: boolean }) {
  return (
    <div className="flex flex-1 items-start justify-center p-8">
      <div className="panel max-w-xl rounded-lg p-6">
        <div className="mb-2 flex items-center gap-2 text-base font-semibold"><MonitorX size={18} /> {screen.title}</div>
        <p className="mb-3">{screen.settings?.neden ?? (notImplemented ? `Bu ekranın web bileşeni (${screen.settings?.bilesen}) bu sürümde bulunmuyor.` : 'Bu işlem web uygulamasında desteklenmiyor.')}</p>
        {screen.description && <p className="text-xs muted">{screen.description}</p>}
        <p className="mt-3 text-xs muted">Menü kodu: {screen.tag}</p>
      </div>
    </div>
  );
}
